import React from "react";
import styled, { keyframes } from "styled-components";

const Loading = () => <Spinner />;

const animation = keyframes`
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
`;

const Spinner = styled.div`
  border-radius: 50%;
  width: 10em;
  height: 10em;
  margin: 60px auto;
  font-size: 10px;
  position: relative;
  text-indent: -9999em;
  border-top: 1.1em solid rgba(238, 146, 54, 0.2);
  border-right: 1.1em solid rgba(238, 146, 54, 0.2);
  border-bottom: 1.1em solid rgba(238, 146, 54, 0.2);
  border-left: 1.1em solid ${({theme}) => theme.colors.primary};
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);

  &::after {
    border-radius: 50%;
    width: 10em;
    height: 10em;
  }

  animation: ${animation} 1.1s linear infinite;
`

export default Loading;
